import { render, staticRenderFns } from "./system-simulation-dynamic-payment.vue?vue&type=template&id=6ca96c0e&scoped=true"
import script from "./system-simulation-dynamic-payment.vue?vue&type=script&lang=js"
export * from "./system-simulation-dynamic-payment.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-dynamic-payment.vue?vue&type=style&index=0&id=6ca96c0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca96c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca96c0e')) {
      api.createRecord('6ca96c0e', component.options)
    } else {
      api.reload('6ca96c0e', component.options)
    }
    module.hot.accept("./system-simulation-dynamic-payment.vue?vue&type=template&id=6ca96c0e&scoped=true", function () {
      api.rerender('6ca96c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/system-simulation-dynamic-payment.vue"
export default component.exports